import { ComponentName } from './detailsDrawersHelpers';
import { UserDetails } from '../../Pages/Admin/Tabs/User/UserDetails';
import { AssetDetails } from '../../Pages/Asset/AssetDetail';
import { DrawerData } from '../../../store/Drawer';
import { User } from '../../../store/User';
import { Asset } from '../../../store/Asset';
import { RpmAccount } from '../../../store/RpmAccount';
import { RPMAccountDetails } from '../../Pages/RPM/RPMAccountDetail';
import { SupplierMapDetails } from '../../Pages/Data/Tabs/SupplierMap/SupplierMapDetail';
import { ApMapDetails } from '../../Pages/Data/Tabs/ApMap/ApMapDetail';
import { SupplierMap } from '../../../store/SupplierMap';
import { ApMap } from '../../../store/ApMap';
import { DrawerActions } from './DrawerActions/DrawerActions';
import { ProvisionalAssetDetails } from '../../Pages/ProvisionalAsset/ProvisionalAssetDetail';
import { ProvisionalAsset } from '../../../store/ProvisionalAsset';
import { LinkDetails } from '../../Pages/Link/LinkDetail';
import { Link } from '../../../store/Link';
import { ProductMap } from '../../../store/ProductMap';
import { ProductMapDetails } from '../../Pages/Data/Tabs/ProductMap/ProductMapDetail';
import { CustomerMapDetails } from '../../Pages/Data/Tabs/CustomerMap/CustomerMapDetail';
import { CustomerMap } from '../../../store/CustomerMap';
import { RunTotalAuditDetails } from '../../Pages/Admin/Tabs/RunTotalAudit/RunTotalAuditDetail';
import { RunTotalAudit } from '../../../store/RunTotalAudit';
import { PaymentDetails } from '../../Pages/Payment/PaymentDetail';
import { Payment } from '../../../store/Payment';
import { RecipientDetails } from '../../Pages/Payment/RecipientDetail';
import { PaymentRecipient } from '../../../store/PaymentRecipient';
import { Correction } from '../../../store/Correction';
import { CorrectionDetails } from '../../Pages/Correction/CorectionDetail';
import { Ticket } from '../../../store/Ticket';
import { TicketDetails } from '../../Pages/Ticket/TicketDetail';
import { Adjustment } from '../../../store/Adjustment';
import { AdjustmentDetails } from '../../Pages/Adjustment/AdjustmentDetail';

export interface DetailsDisplayProps {
  data: DrawerData;
  componentName?: ComponentName;
  deleteAction?: () => void;
}

export const DetailsDisplay = ({ data, componentName, deleteAction }: DetailsDisplayProps) => {
  if (!componentName) return <div></div>;

  const getComponentByName = () => {
    switch (componentName) {
      case ComponentName.USER:
        return <UserDetails data={data as User} />;
      case ComponentName.ASSET:
        return <AssetDetails data={data as Asset} />;
      case ComponentName.PROVISIONAL_ASSET:
        return <ProvisionalAssetDetails data={data as ProvisionalAsset} />;
      case ComponentName.RPM_ACCOUNT:
        return <RPMAccountDetails data={data as RpmAccount} />;
      case ComponentName.SUPPLIER_MAP:
        return <SupplierMapDetails data={data as SupplierMap} />;
      case ComponentName.AP_MAP:
        return <ApMapDetails data={data as ApMap} />;
      case ComponentName.LINK:
        return <LinkDetails data={data as Link} />;
      case ComponentName.RUN_TOTAL_AUDIT:
        return <RunTotalAuditDetails data={data as RunTotalAudit} />;
      case ComponentName.PRODUCT_MAP:
        return <ProductMapDetails data={data as ProductMap} />;
      case ComponentName.CUSTOMER_MAP:
        return <CustomerMapDetails data={data as CustomerMap} />;
      case ComponentName.PAYMENT:
        return <PaymentDetails data={data as Payment} />;
      case ComponentName.PAYMENT_RECIPIENT:
        return <RecipientDetails data={data as PaymentRecipient} />;
      case ComponentName.CORRECTION:
        return <CorrectionDetails data={data as Correction} />;
      case ComponentName.ADJUSTMENT:
        return <AdjustmentDetails data={data as Adjustment} />;
      case ComponentName.TICKET:
        return <TicketDetails data={data as Ticket} />;
      default:
        return null;
    }
  };

  return (
    <>
      {
        <DrawerActions
          componentName={componentName}
          data={data as User | SupplierMap | Link | ApMap | ProductMap | CustomerMap | RunTotalAudit | Correction}
          deleteAction={deleteAction}
        />
      }
      {getComponentByName()}
    </>
  );
};
